import { TMenuLeaf } from '../components/types';
import {
    LEAD_AUTH,
    LEAD_SHOWROOM_AUTH,
    LEAD_BDC_AUTH,
    RECORDINGS_AUTH,
    INVOICES_AUTH,
    LEAD_TASKS_CALENDAR_AUTH,
    TASKS_AUTH,
    LEAD_APPOINTMENTS_CALENDAR_AUTH,
    DOCUMENTS_AUTH,
    USER_AUTH,
    EMAIL_MARKETING_AUTH,
    SERVICE_CLIENT_AUTH,
    CONTACT_AUTH,
} from 'src/constants/permissions';

export const MANAGEMENT_MENU: TMenuLeaf[] = [
    {
        path: '/management/leads',
        title: 'Navbar.Leads',
        permission: LEAD_AUTH,
    },
    {
        path: '/management/showroom-leads',
        title: 'Navbar.ShowroomLeads',
        permission: LEAD_SHOWROOM_AUTH,
    },
    {
        path: '/management/bdc',
        title: 'Navbar.bdc',
        permission: LEAD_BDC_AUTH,
    },
    {
        path: '/management/service-clients',
        title: 'Navbar.ServiceClients',
        permission: SERVICE_CLIENT_AUTH,
    },
    {
        path: '/management/contacts',
        title: 'Navbar.Contacts',
        permission: CONTACT_AUTH,
    },
    {
        path: '/management/recordings',
        title: 'Navbar.Recordings',
        permission: RECORDINGS_AUTH,
    },
    {
        path: '/management/closures',
        title: 'Navbar.Closures',
        permission: INVOICES_AUTH,
    },
    {
        title: 'Navbar.Documents',
        path: '/management/documents',
        permission: DOCUMENTS_AUTH,
    },
    {
        title: 'Navbar.EmailMarketing',
        path: '/management/email-marketing',
        permission: EMAIL_MARKETING_AUTH,
    },
    {
        title: 'Navbar.Users',
        path: '/management/users',
        permission: USER_AUTH,
    },
    {
        path: '/management/tasks',
        title: 'Navbar.Tasks',
        permission: TASKS_AUTH,
    },
    {
        path: '/tasks',
        title: 'Navbar.Calendar',
        permission: LEAD_TASKS_CALENDAR_AUTH,
    },
    {
        path: '/calendar',
        title: 'Navbar.Appointments',
        permission: LEAD_APPOINTMENTS_CALENDAR_AUTH,
    },
];
